import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ISendWhatsappBulkMessagePayload } from "../bulkWhatsappModel";

export const findContactsByState = createAsyncThunk(
  "BulkWhatsapp/FindAllContactByState",
  async (payload: { StateID: number }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/FindAllContactByState`,
        payload,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Contacts by State:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const sendWhatsappBulkMessage = createAsyncThunk(
  "BulkWhatsapp/SendWhatsappMessage",
  async (payload: ISendWhatsappBulkMessagePayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsappSendMessage/SendWhatsappMessage`,
        payload,
      );
      SuccessToast(response.data?.Details || "Messages sent successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Failed to send messages");
      console.error("Error Sending Whatsapp Message:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getWhatsAppTemplateApi = createAsyncThunk(
  "BulkWhatsapp/GetWhatsAppTemplate",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/WhatsappSendMessage/GetWhatsAppTemplate`,
        {
          params: {
            offset: 0,
            template_name: "",
            autosubmitted_for: "",
            approval_status: "",
            variable_present: "",
            language: "",
          },
        },
      );
      const templates = response.data || {};
      // return templates;
      return {
        ...templates,
        Body: {
          ...templates.Body,
          results: {
            templates: [
              ...(templates.Body?.results?.templates || []),
              // {
              //   id: "12345678-abcd-1234-efgh-1234567890ab",
              //   name: "booking_confirmation",
              //   display_name: "Booking Confirmation",
              //   language: "en",
              //   category: "UTILITY",
              //   header_format: "TEXT",
              //   header: "Booking Confirmation",
              //   body: "Hi {{1}},\n\nYour booking (ID: {{2}}) at Kavish Resort has been confirmed.\n\nCheck-in Date: {{3}}\n\nTotal Amount: ₹{{4}}\n\nWe look forward to welcoming you. Have a wonderful stay!",
              //   footer: "Kavish Resort",
              //   buttons: null,
              //   approval_status: "APPROVED",
              //   variable_present: "Yes",
              // },
            ],
          },
        },
      };
    } catch (error: any) {
      console.error("Error Fetching WhatsApp Templates:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
